import { render } from "./TGHomePage.vue?vue&type=template&id=498020a4"
import script from "./TGHomePage.vue?vue&type=script&lang=js"
export * from "./TGHomePage.vue?vue&type=script&lang=js"

import "./TGHomePage.vue?vue&type=style&index=0&id=498020a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__